import React from 'react';
import {Modal,Header,Icon,Button,Message} from 'semantic-ui-react';
import { useTranslation } from "react-i18next";

import './ModalError.scss';

//Import Actions
import {MODAL_ERROR_OK} from 'actions/rootActions';

function getModalErrorContents(modal, t) {
    const responseData = modal?.response?.data;
    if (responseData && typeof responseData === 'object') {
        return {
            message: responseData.message || t('modal.error.default_message'),
            details: responseData.details,
        };
    }
    if (typeof responseData === 'string') {
        return {
            message: responseData,
            details: '',
        };
    }

    const rawMessage = modal?.message || '';
    if (
        modal?.code === 'ECONNABORTED' ||
        rawMessage.toLowerCase().includes('timeout')
    ) {
        return {
            message: t('modal.error.timeout_message'),
            details: t('modal.error.timeout_details'),
        };
    }

    return {
        message: rawMessage || t('modal.error.default_message'),
        details: modal?.details || '',
    };
}

function formatModalErrorDetails(details) {
    if (!details) {
        return '';
    }
    if (typeof details === 'string') {
        return details;
    }
    return JSON.stringify(details, undefined, 2);
}

function ModalError (props){
    const { t } = useTranslation();
    const message = getModalErrorContents(props.modal, t);
    const details = formatModalErrorDetails(message.details);
    return(
        <Modal open={true} className="modalError">
            <Header icon='times' content={t('modal.error.header')} />
            <Modal.Content>
                <Message negative>
                    <Message.Header>{message.message}</Message.Header>
                    {details ? <pre>{details}</pre> : null}
                </Message>
            </Modal.Content>
            <Modal.Actions>
                <Button color='red' onClick={()=>{props.onModalButtonClick(MODAL_ERROR_OK,{})}}>
                    <Icon name='remove' /> OK
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

export default ModalError;
